<template>
  <div>
    <v-dialog
      v-model="show"
      width="60vw"
      max-width="calc(100vw - 30px)"
    >
      <v-card v-if="show">
        <v-card-title>
          Position history
          <v-spacer></v-spacer>
          <v-btn icon small @click.prevent="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            dense
            :headers="headers"
            :items="history"
          >
            <template v-slot:[`item.From_Date`]="{ item, index }">
              <span v-if="editMode !== index">
                {{ item.From_Date | dateFilter }}
              </span>
              <DatePicker
                v-if="editMode === index"
                v-model="dateFrom"
                :min="minDate"
                :max="maxDate"
              />
            </template>
            <template v-slot:[`item.Status_Descr`]="{ item, index }">
              <span v-if="editMode !== index">
                {{ item.Status_Descr }}
              </span>
               <v-select
                  v-if="editMode === index"
                  v-model="currentStatusId"
                  :items="emplStatuses"
                  item-text="Status_Descr"
                  item-value="Status_ID"
                ></v-select>
            </template>
            <template v-slot:[`item.Actions`]="{ item, index }">
              <v-btn
                icon
                small
                :disabled="addNewState || (editMode > -1 && editMode !== index)"
                :color="editMode === index ? 'success' : 'primary'"
                @click.prevent="updateStatus(index, item)"
              >
                <v-icon>{{editMode === index ? 'mdi-check-circle' : 'mdi-pencil-circle'}}</v-icon>
              </v-btn>
              <v-btn
                v-if="editMode === index"
                icon
                small
                color="primary"
                @click.prevent="editMode = -1"
              >
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                color="red darken-2"
                :disabled="addNewState || (editMode > -1 && editMode !== index)"
                v-if="editMode !== index"
                @click.prevent="openRemoveDialog(item.ESH_ID)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`body.append`] v-if="canEdit">
              <td
                class="px-4"
                :class="{
                  'v-data-table__divider': addNewState
                }"
              >
                <DatePicker
                  v-if="addNewState"
                  v-model="dateFrom"
                  :min="minDate"
                  :max="maxDate"
                />
              </td>
              <td
                class="px-4"
                :class="{
                  'v-data-table__divider': addNewState
                }"
              >
                <v-select
                  v-if="addNewState"
                  v-model="currentStatusId"
                  :items="emplStatuses"
                  item-text="Status_Descr"
                  item-value="Status_ID"
                ></v-select>
              </td>
              <td class="no-wrap text-center">
                <v-btn
                  small
                  icon
                  color="success"
                  :disabled="editMode > -1"
                  @click.prevent="addNew"
                >
                  <v-icon>{{ addNewState ? 'mdi-check-circle' : 'mdi-plus-circle' }}</v-icon>
                </v-btn>
                <v-btn
                  v-if="addNewState"
                  icon
                  small
                  color="primary"
                  @click.prevent="addNewState = false"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Remove dialog -->
    <ConfirmOrDeniedDialog
      v-if="removeDialog"
      v-model="removeDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteStatus"
      @onCancelClick="removeDialog = false"
    />
    <!-- /Remove dialog -->
  </div>
</template>
<script>
export default {
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    },
    employee: {
      required: false,
      default: null
    },
    canEdit: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      addNewState: false,
      editMode: -1,
      removeDialog: false,
      idToRemove: null,
      currentStatusId: null,
      currentESHId: null,
      dateFrom: new Date().toISOString().substr(0, 10)
    }
  },
  computed: {
    headers () {
      const h = [
        {
          text: 'From date',
          value: 'From_Date',
          divider: true,
          sortable: this.editMode === -1
        },
        {
          text: 'Position',
          value: 'Status_Descr',
          divider: true,
          width: 200,
          sortable: this.editMode === -1
        }
      ]
      if (this.canEdit) {
        h.push({
          text: '#',
          align: 'center',
          value: 'Actions',
          cellClass: 'no-wrap',
          width: 160,
          sortable: false
        })
      }
      return h
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    user () {
      return this.$store.getters.getUser
    },
    history () {
      return this.employee.Empl_Status_History
    },
    firstStatusId () {
      return this.history[0].ESH_ID
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    minDate () {
      let ind = -1
      let res = null
      const from = this.addNewState ? 0 : 1
      for (let i = 0; i < this.history.length; i++) {
        ind = i > 0 ? i - from : -from
        if (this.currentESHId === this.history[i].ESH_ID) {
          break
        }
      }
      if (ind > -1) {
        const date = new Date(this.history[ind].From_Date)
        res = new Date(date.setDate(date.getDate() + 1)).toISOString().substr(0, 10)
      }
      return res
    },
    maxDate () {
      let ind = -1
      let res = null
      for (let i = 0; i < this.history.length; i++) {
        if (this.currentESHId === this.history[i].ESH_ID) {
          ind = i < this.history.length - 1 ? i + 1 : -1
          break
        }
      }
      if (ind > -1) {
        const date = new Date(this.history[ind].From_Date)
        res = new Date(date.setDate(date.getDate() - 1)).toISOString().substr(0, 10)
      }
      return res
    },
    emplStatuses () {
      return this.$store.getters.getStatuses
    }
  },
  methods: {
    openRemoveDialog (id) {
      this.idToRemove = id
      this.removeDialog = true
    },
    updateStatus (index, item) {
      if (this.editMode > -1) {
        const body = {
          ESH_ID: item.ESH_ID,
          Employee_ID: this.employee.Employee_ID,
          Status_ID: this.currentStatusId,
          From_Date: this.dateFrom
        }
        this.axios.put(`/api/empl_status_history/${body.ESH_ID}`, body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          for (let i = 0; i < this.history.length; i++) {
            if (this.history[i].ESH_ID === item.ESH_ID) {
              this.history[i] = res.data[0]
              break
            }
          }
          this.$store.dispatch('updateEmployeeStatus', { employeeId: this.employee.Employee_ID, statuses: this.history })
          this.$store.dispatch('setSuccess', { successMsg: 'Position successfully updated' })
          this.currentStatusId = null
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.dateFrom = new Date(item.From_Date).toISOString().substr(0, 10)
        this.currentESHId = item.ESH_ID
        this.currentStatusId = item.Status_ID
      }
      this.editMode = this.editMode > -1 ? -1 : index
    },
    addNew () {
      if (this.addNewState) {
        const body = {
          Employee_ID: this.employee.Employee_ID,
          Status_ID: this.currentStatusId,
          From_Date: this.dateFrom
        }
        this.axios.post('/api/empl_status_history', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('addEmployeeStatus', { employeeId: this.employee.Employee_ID, status: res.data[0] })
          this.$store.dispatch('setSuccess', { successMsg: 'Position successfully added' })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.currentStatusId = this.employee.Status_ID
      }
      this.addNewState = !this.addNewState
    },
    deleteStatus () {
      this.axios.delete(`/api/empl_status_history/${this.idToRemove}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        for (let i = 0; i < this.history.length; i++) {
          if (this.history[i].ESH_ID === this.idToRemove) {
            this.$store.dispatch('removeEmployeeStatus', { employeeId: this.employee.Employee_ID, index: i })
            break
          }
        }
        this.removeDialog = false
        this.idToRemove = null
        this.$store.dispatch('setSuccess', { successMsg: 'Position successfully removed' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  },
  filters: {
    dateFilter (val) {
      return new Date(val).toISOString().substr(0, 10)
    }
  }
}
</script>
